export default "<button title=\"{{'BUTTONS.EDIT' | translate}}\" class=\"{{class}}\" (click)=\"edit()\">{{'BUTTONS.EDIT' | translate}}</button>\r\n";